module.exports = __webpack_public_path__ + "img/enfardadores-papercartro.36adfd22.jpg";